import React from 'react'
import './App.css'
import ProductCheckout from './components/ProductCheckout.jsx'
import ProductTrial from './components/ProductTrial.jsx'

function App({productId}) {
  console.log(productId)
  return (
    <>
      <ProductTrial />
    </>
  )
}

export default App
